import { constants as config } from '@config';

module.exports = ElementCreator;

function ElementCreator () {}
ElementCreator.prototype = _.extend({}, Backbone.Events);
ElementCreator.prototype.initialize = function () {
  this.editor = INKIVE.Tool.getInstance().editor;
  this.canvas = this.editor.canvas;
  this.mandatory = [];
  this.defaults = {
    position: { x: 100, y: 100 },
    rotation: 0,
    size: { width: 100, height: 100 },
    opacity: 1
  };

  _.bindAll(this, 'create', 'getDefinedData');
};

ElementCreator.prototype.getDefinedData = function (data, attributeChain) {
  let key; const path = attributeChain.split('.');
  let defaultValue = this.defaults;

  while (path.length > 0) {
    key = path.shift();
    if (typeof data !== 'undefined') data = data[key];
    if (typeof defaultValue !== 'undefined') defaultValue = defaultValue[key];
  }

  return typeof data === 'undefined' ? defaultValue : data;
};

ElementCreator.prototype.getSmartAssetsData = function (element) {
  return Object.values(config.smartAssets.attributes).reduce((data, attribute) => {
    if (element.hasAttribute(attribute)) {
      data[attribute] = element.getAttribute(attribute);
    }

    return data;
  }, {});
};
